// utils/externalTooltip.js
//
// Стандартний тултip Chart.js малюється прямо на canvas — тим самим
// полотном, що й сам донат. Наш білий кружок з підсумком у центрі
// (.publicstatistic-pie-chart-center) — окремий DOM-елемент з z-index
// поверх canvas, тому він фізично перекриває тултip, коли той випадає
// близько до центру (z-index не розрізняє "частини" одного canvas).
//
// Рішення — стандартний патерн Chart.js "external tooltip": тултip
// рендериться як звичайний HTML-елемент, який ми самі позиціюємо і
// кладемо з z-index вище центрального кружка (.publicstatistic-chartjs-
// tooltip у public-statistics.css).
export function externalTooltipHandler(context) {
  const { chart, tooltip } = context;

  let tooltipEl = chart.canvas.parentNode.querySelector('.publicstatistic-chartjs-tooltip');

  if (!tooltipEl) {
    tooltipEl = document.createElement('div');
    tooltipEl.className = 'publicstatistic-chartjs-tooltip';
    chart.canvas.parentNode.appendChild(tooltipEl);
  }

  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body.map(b => b.lines).flat();

    let innerHtml = '';
    titleLines.forEach(title => {
      innerHtml += `<div class="publicstatistic-chartjs-tooltip-title">${title}</div>`;
    });
    bodyLines.forEach(line => {
      innerHtml += `<div class="publicstatistic-chartjs-tooltip-body">${line}</div>`;
    });

    tooltipEl.innerHTML = innerHtml;
  }

  const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

  tooltipEl.style.opacity = 1;
  tooltipEl.style.left = positionX + tooltip.caretX + 'px';
  tooltipEl.style.top = positionY + tooltip.caretY + 'px';
}